/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/
import { eventEmitter, lang, sessid } from './common/baseData'

import ReactDOM from 'react-dom'
import React, { Suspense, lazy, useEffect, useState } from 'react'

import Cookies from 'js-cookie'
import './shops/style.css'
import './catalog/style.css'
import './catalog/filter/style.css'

import './pagenavigation/style.css'
import ProductFilter from './components/searchPage/productFilter/ProductFilter'
import ProductList from './components/searchPage/productList/ProductList'
import ViewedProductsSlider from './components/viewedProductsSlider/ViewedProductsSlider'
import LoadingBlock from './components/loadingBlock'
import axios from 'axios'
import SortList from './components/searchPage/sortList/SortList'
import {createRoot} from 'react-dom/client';

let searchPageNode = document.getElementById('search-page-root')
if (searchPageNode instanceof HTMLElement) {
  let initial = JSON.parse(atob(window.searchPageData))
  let breadcrumbs = JSON.parse(window.breadcrumbs)
  if (initial) {
    const searchPageRoot = createRoot(searchPageNode)
    searchPageRoot.render(
      <Suspense fallback={<LoadingBlock/>}>
        <SearchPage initial={initial}
                    breadcrumbs={breadcrumbs}
                    searchResult={initial.searchResult}/>
      </Suspense>
    )
  }
}

function SearchPage (props) {
  const [searchResult, setSearchResult] = useState(props.searchResult)
  const [state, setState] = useState(props.initial)
  const [checkedFilters, setCheckedFilters] = useState({})
  const [needRefresh, setNeedRefresh] = useState(false)
  const [ordering, setOrdering] = useState({sort: 'relevance', order: 'asc'})
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(24)
  const [showMobileFilter, setShowMobileFilter] = useState(false)

  // изменение выбранных фильтров
  useEffect(() => {
    if (!needRefresh) return

    let data = {
      filter: checkedFilters,
      limit: limit,
      sort: ordering.sort,
      order: ordering.order,
      page: 1,
      query: state.query,
      lang: lang,
      sessid: sessid
    }

    eventEmitter.emit('showLoader')

    axios.post(state.asyncUrl, data, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => {
        eventEmitter.emit('hideLoader')
        //console.info(response)
        setNeedRefresh(false)
        let responseData = response.hasOwnProperty('data') ? response.data : null
        if (responseData) {
          if (responseData.hasOwnProperty('products')) {
            setState({ ...state, products: responseData.products, totalMessage: responseData.totalMessage })
            setPage(responseData.searchResult.page)
          }
          if (responseData.hasOwnProperty('searchResult')) setSearchResult(responseData.searchResult)
        }
      })
      .catch(reason => {
        console.error(reason)
        setNeedRefresh(false)
        eventEmitter.emit('hideLoader')
      })
  }, [needRefresh])

  useEffect(() => {
    // сохраняем последнюю поисковую фразу
    Cookies.set('_ms_search_phase', state.query, { expires: 1 })
    eventEmitter.emit('MSSearch', {})
  }, [])

  // событие клика на overlay
  useEffect(() => {
    let bg = document.querySelector('.bg');
    if (bg instanceof HTMLElement) {
      bg.addEventListener('click', onCloseMobileFilter)
    }
  }, [])

  function onShowMore() {
    let nextPage = page + 1
    let data = {
      filter: checkedFilters,
      limit: limit,
      sort: ordering.sort,
      order: ordering.order,
      page: nextPage,
      query: state.query,
      lang: lang,
      sessid: sessid
    }

    eventEmitter.emit('showLoader')

    axios.post(state.asyncUrl, data, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => {
        eventEmitter.emit('hideLoader')
        //console.info(response)

        let responseData = response.hasOwnProperty('data') ? response.data : null
        if (responseData) {
          if (responseData.hasOwnProperty('products')) {
            let products = state.products.concat(responseData.products)
            setState({ ...state, products: products })
            setPage(responseData.searchResult.page)
          }
        }
      })
      .catch(reason => {
        console.error(reason)
        eventEmitter.emit('hideLoader')
      })
  }

  function onCloseMobileFilter(event) {
    console.info('onCloseMobileFilter', event)
    event.preventDefault()
    setShowMobileFilter(false)
    let bg = document.querySelector('.bg');
    bg.classList.remove('active');
    bg.style.zIndex = 'unset';
  }

  function onShowMobileFilter(event) {
    event.preventDefault()
    setShowMobileFilter(true)
    let bg = document.querySelector('.bg');
    bg.classList.add('active');
    bg.style.zIndex = 1066;
  }

  function onSortChange(sort, order) {
    setOrdering({sort: sort, order: order})
    setNeedRefresh(true)
  }

  function onPriceChange (values) {
    //console.info(values)
    setCheckedFilters({ ...checkedFilters, price: values })
    setNeedRefresh(true)
  }

  function onChange (event) {
    //console.info(event.target)
    let name = event.target.name
    let value = event.target.value
    let checked = event.target.checked
    let tmpFilters = checkedFilters
    let modified = false

    if (checked) {
      if (!tmpFilters.hasOwnProperty(name) || !Array.isArray(tmpFilters[name])) {
        tmpFilters[name] = []
      }
      tmpFilters[name].push(value)
      modified = true
    } else if (tmpFilters.hasOwnProperty(name) && Array.isArray(tmpFilters[name]) && tmpFilters[name].length) {
      // поиск ключа значения
      let index = tmpFilters[name].indexOf(value)
      if (index >= 0) {
        tmpFilters[name].splice(index, 1)
      }
      modified = true
    }

    //console.info(name, value, checked, modified, tmpFilters)

    if (modified) {
      setCheckedFilters(tmpFilters)
      setNeedRefresh(true)
    }
  }

  function getMessage (code) {
    return state.messages.hasOwnProperty(code) ? state.messages[code] : ''
  }

  return (
    <>
      <div className={`filter-section ${showMobileFilter ? 'opened' : ''}`}>
        <ProductFilter filters={searchResult.filters} categories={searchResult.categories}
                       getMessage={getMessage} onChange={onChange} onPriceChange={onPriceChange}
                       onCloseMobileFilter={onCloseMobileFilter}/>
      </div>
      <div className="catalog-holder">
        {
          Array.isArray(props.breadcrumbs) && props.breadcrumbs.length ?
            <div className={'breadcrumbs'}>
              <ul className={'breadcrumbs-list'}>
                {
                  props.breadcrumbs.map((breadcrumb, index) => {
                    return breadcrumb.hasOwnProperty('link') && breadcrumb.link.length ?
                      <li key={index}>
                        <a href={breadcrumb.link} title={breadcrumb.htmlTitle}>{breadcrumb.title}</a>
                      </li> :
                      <li key={index}>{breadcrumb.title}</li>
                  })
                }
              </ul>
            </div> :
            <></>
        }
        <div className="title-section">
          <div className="title-h1">
            <h1 className="title-name">{getMessage('PAGE_TITLE')}</h1>
            <span className="count">{`(${searchResult.total} ${state.totalMessage})`}</span>
          </div>
          <div className="sorted-panel flex-row-reverse desktop:flex-row">
            <div className="filter-link">
              <a href="#" onClick={onShowMobileFilter}>{getMessage('FILTERS')}</a>
            </div>
            <SortList getMessage={getMessage} ordering={ordering} onChange={onSortChange}/>
          </div>
          <ProductList products={state.products} getMessage={getMessage}/>
          {
            searchResult.total / limit > page ?
              <div className={'paging-panel'}>
                <div className="show-more">
                  <div className="link-show-more" onClick={onShowMore}>
                    <i className="icon-showing-more"></i>
                    <span>{getMessage('CT_BCS_CATALOG_MESS_BTN_LAZY_LOAD')}</span>
                  </div>
                </div>
              </div> :
              <></>
          }
        </div>
      </div>
    </>
  )
}

// Просмотренные твоары
new ViewedProductsSlider().init()
